import { useNavigate } from "react-router-dom";
import Logo from "../design/Logo";
import CardText from "../design/CardText";
import CardTextNumber from "../design/CardTextNumber";
import Frame from "../design/Frame";
import { useRecoilState, useRecoilValue } from "recoil";
import { userStateAtom } from "../atoms/userStateAtom";
import SelectGenreForm from "./SelectGenreForm";
import { formFlowAtom } from "./Atom/formFlowAtom";
import DesignedButton from "../design/DesignedButton";
import SelectDetailedGenreForm from "./SelectDetailedGenreForm";
import SelectAgeForm from "./SelectAgeForm";
import SelectMainThemeForm from "./SelectMainThemeForm";
import { writingDetailInfoAtom } from "./Atom/writingDetailInfoAtom";
import WriteAnswersForm from "./WriteAnswersForm";

const MakeCreateLearning = () => {
  const navigate = useNavigate();
  const user = useRecoilValue(userStateAtom);
  const userID = user.userData.userIdphp;
  const [flow, setFlow] = useRecoilState(formFlowAtom);
  const submittedForm = useRecoilValue(writingDetailInfoAtom);
  //0. 시작전, 1. Genre, 2. Detailed Genre, 3. Age, 4. mainTheme, 5. questions-answers, 6.make-writings
  const onStartMake = () => {
    setFlow(1);
  };
  console.log(submittedForm);
  return (
    <Frame>
      <div className="text-3xl font-bold mb-5">창작하기📚💬</div>
      {flow === 0 ? (
        <DesignedButton
          color="blue"
          text="만들기"
          onClickFunction={onStartMake}
        />
      ) : (
        ""
      )}

      {flow === 1 ? <SelectGenreForm /> : ""}
      {flow === 2 ? <SelectDetailedGenreForm /> : ""}
      {flow === 3 ? <SelectAgeForm /> : ""}
      {flow === 4 ? <SelectMainThemeForm /> : ""}
      {flow === 5 ? <WriteAnswersForm /> : ""}
    </Frame>
  );
};

export default MakeCreateLearning;
